import React from 'react';
import { defaultIconProps } from './common';
const CirclePlus = ({ primaryColor, width, height }) => (React.createElement("svg", { width: width, height: height, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { width: 28, height: 28, rx: 14, fill: primaryColor }),
    React.createElement("path", { d: "M15.16 6.863a1.167 1.167 0 00-2.326.136v5.833H7.001l-.136.008A1.167 1.167 0 007 15.165h5.833V21l.008.136a1.167 1.167 0 002.325-.136v-5.834h5.834l.136-.007A1.167 1.167 0 0021 12.832h-5.834V6.999l-.008-.136z", fill: "#fff" })));
CirclePlus.defaultProps = defaultIconProps;
export default CirclePlus;
